import { Button } from '@cian/ui-kit';
import { IconFileTrash16 } from '@cian/ui-kit-design-tokens/icons';
import * as React from 'react';

export interface IDeleteButtonProps {
  showPreloader: boolean;
  onDeleteCommentClick(): void;
}

export class DeleteButton extends React.PureComponent<IDeleteButtonProps, {}> {
  public render() {
    const { onDeleteCommentClick, showPreloader } = this.props;

    return (
      <Button
        size="XS"
        loading={showPreloader}
        onClick={onDeleteCommentClick}
        theme="fill_secondary"
        beforeIcon={<IconFileTrash16 color="icon-main-default" />}
        title="Удалить заметку"
      />
    );
  }
}
